import pkg from 'package.json';

const DEVICE_ID = 'TIGER_WEB_ID';

class Device {
    constructor() {
        try {
            // @ts-ignore
            this.deviceId = typeof localStorage === 'object' && localStorage.getItem(DEVICE_ID);
        } catch (err) {
            //
        }

        if (!this.deviceId) {
            this.deviceId = Device.genUUID();

            typeof localStorage === 'object' && localStorage.setItem(DEVICE_ID, this.deviceId);
        }
    }

    deviceId: string;

    appVer = pkg.version;
    vendor = 'web';
    lang = 'en_US';
    platform = 'web';
    category = 'Individual_US';

    static genUUID(prefix = 'web_') {
        let d = +new Date();
        let uuid =
            prefix +
            'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxx'.replace(/[xy]/g, function(c) {
                let r = (d + Math.random() * 16) % 16 | 0;

                d = Math.floor(d / 16);

                return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
            });

        return uuid;
    }
}

export default Device;
